module.exports = __webpack_public_path__ + "static/media/2-aldri.bf342e4a.mp3";